// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import Chart from 'chart.js'; // Correct import for chart.js 2.9.4

// class DataTable extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             data: {},
//             loading: true,
//             error: false,
//             selectedTab: 'FICHA_ENCUESTA'
//         };
//     }

//     componentDidMount() {
//         // Fetch data from the API
//         fetch('https://quality.fiestaismadrid.net/api/survey/list')
//             .then(response => {
//                 // console.log(response.json(),"response")
//                 if (!response.ok) {
//                     throw new Error('Network response was not ok');
//                 }
//                 return response.json();
//             })
//             .then(jsonData => {
//                 console.log(jsonData,"dsds"); // Log JSON data to inspect structure

//                 this.setState({
//                     data: jsonData,
//                     loading: false,
//                     error: false
//                 });
//             })
//             .catch(error => {
//                 console.error('Error fetching data:', error);
//                 this.setState({
//                     loading: false,
//                     error: true
//                 });
//             });
//     }

//     generateColors(dataLength) {
//         const colors = [];
//         for (let i = 0; i < dataLength; i++) {
//             const r = Math.floor(Math.random() * 256);
//             const g = Math.floor(Math.random() * 256);
//             const b = Math.floor(Math.random() * 256);
//             colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
//         }
//         return colors;
//     }

//     renderChart(data, labelKey, countKey, chartLabel) {
//         const labels = data.map(item => item[labelKey]);
//         const counts = data.map(item => parseInt(item[countKey]));

//         const chartData = {
//             labels: labels,
//             datasets: [
//                 {
//                     label: chartLabel,
//                     data: counts,
//                     backgroundColor: this.generateColors(counts.length),
//                     borderWidth: 1
//                 }
//             ]
//         };

//         return (
//             <Bar
//                 data={chartData}
//                 options={{
//                     maintainAspectRatio: false,
//                     scales: {
//                         yAxes: [{
//                             ticks: {
//                                 beginAtZero: true
//                             }
//                         }]
//                     }
//                 }}
//             />
//         );
//     }

//     render() {
//         const { data, loading, error, selectedTab } = this.state;

//         if (loading) {
//             return <div><p>Cargando...</p></div>;
//         }

//         if (error) {
//             return <div><p>Error al obtener los datos</p></div>;
//         }

//         const tabData = data[selectedTab] || {};

//         return (
//             <div style={{ width: '100%', padding: '20px' }}>
//                 <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//                     <button onClick={() => this.setState({ selectedTab: 'FICHA_ENCUESTA' })} style={{ marginRight: '10px' }}>FICHA ENCUESTA</button>
//                     <button onClick={() => this.setState({ selectedTab: 'FICHA_AMBIENTE' })} style={{ marginRight: '10px' }}>FICHA AMBIENTE</button>
//                     <button onClick={() => this.setState({ selectedTab: 'instalaciones_funcionamiento' })}>INSTALACIONES FUNCIONAMIENTO</button>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                     {selectedTab === 'FICHA_ENCUESTA' && (
//                         <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%' }}>
//                             {tabData.licenciadata && (
//                                 <div style={{ width: '48%', height: '400px', marginBottom: '20px', marginRight: '2%' }}>
//                                     {this.renderChart(tabData.licenciadata, 'licencia', 'count', 'Número de Establecimientos por Licencia')}
//                                 </div>
//                             )}
//                             {tabData.dimensionesdata && (
//                                 <div style={{ width: '48%', height: '400px', marginBottom: '20px' }}>
//                                     {this.renderChart(tabData.dimensionesdata, 'dimensiones', 'count', 'Número de Establecimientos por Dimensiones')}
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                     {selectedTab === 'FICHA_AMBIENTE' && (
//                         <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%' }}>
//                             {tabData.musicaLdata && (
//                                 <div style={{ width: '48%', height: '400px', marginBottom: '20px', marginRight: '2%' }}>
//                                     {this.renderChart(tabData.musicaLdata, 'musicaL', 'count', 'Número de Establecimientos por Música L')}
//                                 </div>
//                             )}
//                             {tabData.musicaMdata && (
//                                 <div style={{ width: '48%', height: '400px', marginBottom: '20px' }}>
//                                     {this.renderChart(tabData.musicaMdata, 'musicaM', 'count', 'Número de Establecimientos por Música M')}
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                     {selectedTab === 'instalaciones_funcionamiento' && (
//                         <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', width: '100%' }}>
//                             {tabData.decoraciondata && (
//                                 <div style={{ width: '48%', height: '400px', marginBottom: '20px', marginRight: '2%' }}>
//                                     {this.renderChart(tabData.decoraciondata, 'decoracion', 'count', 'Número de Establecimientos por Decoración')}
//                                 </div>
//                             )}
//                             {tabData.limp_durantedata && (
//                                 <div style={{ width: '48%', height: '400px', marginBottom: '20px' }}>
//                                     {this.renderChart(tabData.limp_durantedata, 'limp_durante', 'count', 'Número de Establecimientos por Limpieza Durante')}
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </div>
//         );
//     }
// }

// export default DataTable;

//------------------------------------------------------=================================

// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import Chart from 'chart.js'; // Correct import for chart.js 2.9.4

// class DataTable extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             data: {},
//             loading: true,
//             error: false,
//             selectedTab: ''
//         };
//     }

//     componentDidMount() {
//         // Fetch data from the API
//         fetch('https://quality.fiestaismadrid.net/api/survey/list')
//             .then(response => {
//                 if (!response.ok) {
//                     throw new Error('Network response was not ok');
//                 }
//                 return response.json();
//             })
//             .then(jsonData => {
//                 console.log(jsonData); // Log JSON data to inspect structure

//                 // Set the first tab as selectedTab by default if data is not empty
//                 const firstTab = Object.keys(jsonData)[0] || '';

//                 this.setState({
//                     data: jsonData,
//                     loading: false,
//                     error: false,
//                     selectedTab: firstTab
//                 });
//             })
//             .catch(error => {
//                 console.error('Error fetching data:', error);
//                 this.setState({
//                     loading: false,
//                     error: true
//                 });
//             });
//     }

//     generateColors(dataLength) {
//         const colors = [];
//         for (let i = 0; i < dataLength; i++) {
//             const r = Math.floor(Math.random() * 256);
//             const g = Math.floor(Math.random() * 256);
//             const b = Math.floor(Math.random() * 256);
//             colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
//         }
//         return colors;
//     }

//     getChartLabel(chartKey) {
//         const chartLabels = {
//             musicaLdata: 'Ambience Monday',
//             musicaMdata: 'Ambience Tuesday',
//             musicaXdata: 'Ambience Wednesday',
//             MusicaJdata: 'Ambience Thursday',
//             musicaVdata: 'Ambience Friday',
//             musicaSdata: 'Ambience Saturday',
//             musicaDdata: 'Ambience Sunday',
//             edaddata: 'Ambience Age',
//             poderdata: 'Ambience Power',
//             aspectodata: 'Ambience Aspect'
//         };
//         return chartLabels[chartKey] || chartKey.replace(/_/g, ' ');
//     }

//     renderChart(data, labelKey, countKey, chartLabel) {
//         const labels = data.length > 0 ? data.map(item => item[labelKey]) : ['No Data'];
//         const counts = data.length > 0 ? data.map(item => parseInt(item[countKey])) : [0];

//         const chartData = {
//             labels: labels,
//             datasets: [
//                 {
//                     label: chartLabel,
//                     data: counts,
//                     backgroundColor: this.generateColors(counts.length),
//                     borderWidth: 1
//                 }
//             ]
//         };

//         return (
//             <Bar
//                 data={chartData}
//                 options={{
//                     maintainAspectRatio: false,
//                     scales: {
//                         yAxes: [{
//                             ticks: {
//                                 beginAtZero: true
//                             }
//                         }]
//                     }
//                 }}
//                 height={385}
//                 width={400}
//             />
//         );
//     }

//     render() {
//         const { data, loading, error, selectedTab } = this.state;

//         if (loading) {
//             return <div><p>Cargando...</p></div>;
//         }

//         if (error) {
//             return <div><p>Error al obtener los datos</p></div>;
//         }

//         const tabData = data[selectedTab] || {};

//         return (
//             <div style={{ width: '100%', padding: '20px' }}>
//                 <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//                     {Object.keys(data).map(tab => (
//                         <button
//                             key={tab}
//                             onClick={() => this.setState({ selectedTab: tab })}
//                             style={{ marginRight: '10px' }}
//                         >
//                             {tab.replace(/_/g, ' ')}
//                         </button>
//                     ))}
//                 </div>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
//                     {Object.keys(tabData).map((chartKey, index) => (
//                         <div
//                             key={index}
//                             style={{ marginBottom: '20px' }}
//                         >
//                             {this.renderChart(
//                                 tabData[chartKey],
//                                 Object.keys(tabData[chartKey][0] || {})[0] || 'No Data',
//                                 'count',
//                                 this.getChartLabel(chartKey)
//                             )}
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         );
//     }
// }

// export default DataTable;


// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import Chart from 'chart.js'; // Correct import for chart.js 2.9.4
// import marketing from '../../public/images/Marketing.png';
// import ambientacion from '../../public/images/Ambientacion.png';
// import horarios from '../../public/images/Horarios.png';
// import datosGenerales from '../../public/images/DatosGenerales.png';
// import entorno from '../../public/images/Entorno.png';
// import espectaculo from '../../public/images/Espectaculo.png';
// import instalacion from '../../public/images/Instalacion.png';
// import personal from '../../public/images/Personal.png';
// import precios from '../../public/images/Precios.png';
// import rCSbuenasPracticas from '../../public/images/RCSbuenasPracticas.png';
// import rCSmalasPracticas from '../../public/images/RCSmalasPracticas.png';
// import seguridad from '../../public/images/Seguridad.png';
// import servicio from '../../public/images/Servicio.png';
// import valoracion from '../../public/images/valoracion.png';


// class DataTable extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             data: {},
//             loading: true,
//             error: false,
//             selectedTab: ''
//         };
//     }

//     componentDidMount() {
//         // Fetch data from the API
//         fetch('https://quality.fiestaismadrid.net/api/survey/list')
//             .then(response => {
//                 if (!response.ok) {
//                     throw new Error('Network response was not ok');
//                 }
//                 return response.json();
//             })
//             .then(jsonData => {
//                 console.log(jsonData); // Log JSON data to inspect structure

//                 // Set the first tab as selectedTab by default if data is not empty
//                 const firstTab = Object.keys(jsonData)[0] || '';

//                 this.setState({
//                     data: jsonData,
//                     loading: false,
//                     error: false,
//                     selectedTab: firstTab
//                 });
//             })
//             .catch(error => {
//                 console.error('Error fetching data:', error);
//                 this.setState({
//                     loading: false,
//                     error: true
//                 });
//             });
//     }

//     generateColors(dataLength) {
//         const colors = [];
//         for (let i = 0; i < dataLength; i++) {
//             const r = Math.floor(Math.random() * 256);
//             const g = Math.floor(Math.random() * 256);
//             const b = Math.floor(Math.random() * 256);
//             colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
//         }
//         return colors;
//     }

//     getChartLabel(chartKey) {
//         const chartLabels = {
//             licenciadata: 'Licenses',
//             dimensionesdata: 'Dimensions',
//             horaLde: 'Monday Start Time',
//             horaLa: 'Monday End Time',
//             horaMde: 'Tuesday Start Time',
//             horaMa: 'Tuesday End Time',
//             horaXde: 'Wednesday Start Time',
//             horaXa: 'Wednesday End Time',
//             horaJde: 'Thursday Start Time',
//             horaJa: 'Thursday End Time',
//             horaVde: 'Friday Start Time',
//             horaVa: 'Friday End Time',
//             horaSde: 'Saturday Start Time',
//             horaSa: 'Saturday End Time',
//             horaDde: 'Sunday Start Time',
//             horaDa: 'Sunday End Time',
//             musicaLdata: 'Ambience Monday',
//             musicaMdata: 'Ambience Tuesday',
//             musicaXdata: 'Ambience Wednesday',
//             MusicaJdata: 'Ambience Thursday',
//             musicaVdata: 'Ambience Friday',
//             musicaSdata: 'Ambience Saturday',
//             musicaDdata: 'Ambience Sunday',
//             edaddata: 'Age',
//             poderdata: 'Power',
//             aspectodata: 'Aspect',
//             pistadata: 'Dance Floor',
//             escenariodata: 'Stage',
//             zonamesasdata: 'Table Area',
//             perc_mesasdata: 'Percentage of Tables',
//             barrasdata: 'Bars',
//             barrasmetrosdata: 'Bars Meters',
//             barraspersonsdata: 'Bar Persons',
//             decoraciondata: 'Decoration',
//             climatizaciondata: 'Air Conditioning',
//             climat_tempdata: 'Climate Temperature',
//             limp_durantedata: 'Cleanliness During',
//             limp_ensesiondata: 'Cleanliness In Session',
//             mantenimientodata: 'Maintenance'
//         };
//         return chartLabels[chartKey] || chartKey.replace(/_/g, ' ');
//     }

//     renderChart(data, labelKey, countKey, chartLabel) {
//         const labels = data.length > 0 ? data.map(item => item[labelKey]) : ['No Data'];
//         const counts = data.length > 0 ? data.map(item => parseInt(item[countKey])) : [0];

//         const chartData = {
//             labels: labels,
//             datasets: [
//                 {
//                     label: chartLabel,
//                     data: counts,
//                     backgroundColor:'#349beb',    //this.generateColors(counts.length),
//                     borderWidth: 1
//                 }
//             ]
//         };

//         return (
//             <Bar
//                 data={chartData}
//                 options={{
//                     maintainAspectRatio: false,
//                     scales: {
//                         yAxes: [{
//                             ticks: {
//                                 beginAtZero: true
//                             }
//                         }]
//                     }
//                 }}
// height={385}
// width={400}
//             />
//         );
//     }

//     render() {
//         const { data, loading, error, selectedTab } = this.state;

//         if (loading) {
//             return <div><p>Cargando...</p></div>;
//         }

//         if (error) {
//             return <div><p>Error al obtener los datos</p></div>;
//         }

//         const tabData = data[selectedTab] || {};

//         return (
//             <div style={{ width: '100%', padding: '20px' }}>
//                 <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//                     {Object.keys(data).map(tab => (
//                         <button
//                             key={tab}
//                             onClick={() => this.setState({ selectedTab: tab })}
//                             style={{ marginRight: '10px' }}
//                         >
//                             {tab.replace(/_/g, ' ')}
//                         </button>
//                     ))}
//                 </div>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
//                     {Object.keys(tabData).map((chartKey, index) => (
//                         <div
//                             key={index}
//                             style={{ marginBottom: '20px' }}
//                         >
//                             {this.renderChart(
//                                 tabData[chartKey],
//                                 Object.keys(tabData[chartKey][0] || {})[0] || 'No Data',
//                                 'count',
//                                 this.getChartLabel(chartKey)
//                             )}
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         );
//     }
// }

// export default DataTable;


// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import marketing from '../../public/images/Marketing.png';
// import ambientacion from '../../public/images/Ambientacion.png';
// import horarios from '../../public/images/Horarios.png';
// import datosGenerales from '../../public/images/DatosGenerales.png';
// import entorno from '../../public/images/Entorno.png';
// import espectaculo from '../../public/images/Espectaculo.png';
// import instalacion from '../../public/images/Instalacion.png';
// import personal from '../../public/images/Personal.png';
// import precios from '../../public/images/Precios.png';
// import rCSbuenasPracticas from '../../public/images/RCSbuenasPracticas.png';
// import rCSmalasPracticas from '../../public/images/RCSmalasPracticas.png';
// import seguridad from '../../public/images/Seguridad.png';
// import servicio from '../../public/images/Servicio.png';
// import valoracion from '../../public/images/valoracion.png';

// const tabImages = {
//   FICHA_AMBIENTE: marketing,
//   FICHA_ENCUESTA: ambientacion,
//   horarios: horarios,
//   DatosGenerales: datosGenerales,
//   FICHA_Entorno: entorno,
//   instalaciones_funcionamiento: espectaculo,
//   Instalacion: instalacion,
//   Personal: personal,
//   Precios: precios,
//   RCSbuenasPracticas: rCSbuenasPracticas,
//   RCSmalasPracticas: rCSmalasPracticas,
//   FICHA_Seguridad: seguridad,
//   Servicio: servicio,
//   Valoracion: valoracion
// };

// class DataTable extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: {},
//       loading: true,
//       error: false,
//       selectedTab: ''
//     };
//   }

//   componentDidMount() {
//     fetch('https://quality.fiestaismadrid.net/api/survey/list')
//       .then(response => {
//         if (!response.ok) throw new Error('Network response was not ok');
//         return response.json();
//       })
//       .then(jsonData => {
//         const firstTab = Object.keys(jsonData)[0] || '';
//         this.setState({
//           data: jsonData,
//           loading: false,
//           selectedTab: firstTab
//         });
//       })
//       .catch(error => {
//         console.error('Error fetching data:', error);
//         this.setState({
//           loading: false,
//           error: true
//         });
//       });
//   }

//   generateColors(dataLength) {
//     const colors = [];
//     for (let i = 0; i < dataLength; i++) {
//       const r = Math.floor(Math.random() * 256);
//       const g = Math.floor(Math.random() * 256);
//       const b = Math.floor(Math.random() * 256);
//       colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
//     }
//     return colors;
//   }

//   getChartLabel(chartKey) {
//     const chartLabels = {
//       licenciadata: 'Licenses',
//       dimensionesdata: 'Dimensions',
//       horaLde: 'Monday Start Time',
//       horaLa: 'Monday End Time',
//       horaMde: 'Tuesday Start Time',
//       horaMa: 'Tuesday End Time',
//       horaXde: 'Wednesday Start Time',
//       horaXa: 'Wednesday End Time',
//       horaJde: 'Thursday Start Time',
//       horaJa: 'Thursday End Time',
//       horaVde: 'Friday Start Time',
//       horaVa: 'Friday End Time',
//       horaSde: 'Saturday Start Time',
//       horaSa: 'Saturday End Time',
//       horaDde: 'Sunday Start Time',
//       horaDa: 'Sunday End Time',
//       musicaLdata: 'Ambience Monday',
//       musicaMdata: 'Ambience Tuesday',
//       musicaXdata: 'Ambience Wednesday',
//       MusicaJdata: 'Ambience Thursday',
//       musicaVdata: 'Ambience Friday',
//       musicaSdata: 'Ambience Saturday',
//       musicaDdata: 'Ambience Sunday',
//       edaddata: 'Age',
//       poderdata: 'Power',
//       aspectodata: 'Aspect',
//       pistadata: 'Dance Floor',
//       escenariodata: 'Stage',
//       zonamesasdata: 'Table Area',
//       perc_mesasdata: 'Percentage of Tables',
//       barrasdata: 'Bars',
//       barrasmetrosdata: 'Bars Meters',
//       barraspersonsdata: 'Bar Persons',
//       decoraciondata: 'Decoration',
//       climatizaciondata: 'Air Conditioning',
//       climat_tempdata: 'Climate Temperature',
//       limp_durantedata: 'Cleanliness During',
//       limp_ensesiondata: 'Cleanliness In Session',
//       mantenimientodata: 'Maintenance',
// evacuation_entry: 'evacuacion',
// controlaforo: 'Sistema control aforos',
// hora_actv: 'En que horario se produce el pico de mas activided',
// camaras: 'Cameras de vigilancia',
// ocupacion: 'Grado ocupation espacio',
// Sistema_de_pago: 'Sistema de pago',
// Cuno: 'Cuno salida'
//     };
//     return chartLabels[chartKey] || chartKey.replace(/_/g, ' ');
//   }

//   renderChart(data, labelKey, countKey, chartLabel) {
//     const labels = data.map(item => item[labelKey]);
//     const counts = data.map(item => parseInt(item[countKey]));

//     const chartData = {
//       labels: labels,
//       datasets: [
//         {
//           label: chartLabel,
//           data: counts,
//           backgroundColor: this.generateColors(counts.length),
//           borderWidth: 1
//         }
//       ]
//     };

//     return (
//       <Bar
//         data={chartData}
//         options={{
//           maintainAspectRatio: false,
//           scales: {
//             yAxes: [{
//               ticks: {
//                 beginAtZero: true
//               }
//             }]
//           }
//         }}
//         height={385}
//         width={400}
//       />
//     );
//   }

//   // renderFICHA_Seguridad(data) {
//   //   const renderSingleChart = (key, label) => {
//   //     const dataObj = data[key][0];
//   //     const labels = Object.keys(dataObj);
//   //     const counts = labels.map(label => parseInt(dataObj[label]));

//   //     const chartData = {
//   //       labels: labels,
//   //       datasets: [
//   //         {
//   //           label: label,
//   //           data: counts,
//   //           backgroundColor: this.generateColors(counts.length),
//   //           borderWidth: 1
//   //         }
//   //       ]
//   //     };

//   //     return (
//   //       <div key={key}>
//   //         <Bar
//   //           data={chartData}
//   //           options={{
//   //             maintainAspectRatio: false,
//   //             scales: {
//   //               yAxes: [{
//   //                 ticks: {
//   //                   beginAtZero: true
//   //                 }
//   //               }]
//   //             }
//   //           }}
//   //           height={385}
//   //           width={400}
//   //         />
//   //       </div>
//   //     );
//   //   };

//   // return (
//   //   <div>
//   //     {renderSingleChart('evacuation_entry', 'evacuacion')}
//   //     {renderSingleChart('controlaforo', 'Sistema control aforos')}
//   //     {renderSingleChart('hora_actv', 'En que horario se produce el pico de mas activided')}
//   //     {renderSingleChart('camaras', 'Cameras de vigilancia')}
//   //     {renderSingleChart('ocupacion', 'Grado ocupation espacio')}
//   //     {renderSingleChart('Sistema_de_pago', 'Sistema de pago')}
//   //     {renderSingleChart('Cuno', 'Cuno salida')}
//   //   </div>
//   // );
//   // }

//   renderFICHA_Seguridad(data) {
//     const renderSingleChart = (key) => {  // Removed the 'label' parameter as it's now fetched inside
//       const dataObj = data[key][0];
//       const labels = Object.keys(dataObj);
//       const counts = labels.map(label => parseInt(dataObj[label]));

//       const chartData = {
//         labels: labels,
//         datasets: [{
//           label: this.getChartLabel(key),  // Using getChartLabel to fetch the label dynamically
//           data: counts,
//           backgroundColor: this.generateColors(counts.length),
//           borderWidth: 1
//         }]
//       };

//       return (
//         <div key={key}>
//           <Bar
//             data={chartData}
//             options={{
//               maintainAspectRatio: false,
//               scales: {
//                 yAxes: [{
//                   ticks: {
//                     beginAtZero: true
//                   }
//                 }]
//               }
//             }}
//             height={385}
//             width={400}
//           />
//         </div>
//       );
//     };
//     return (
//       <div>
//         {renderSingleChart('evacuation_entry', 'evacuacion')}
//         {renderSingleChart('controlaforo', 'Sistema control aforos')}
//         {renderSingleChart('hora_actv', 'En que horario se produce el pico de mas activided')}
//         {renderSingleChart('camaras', 'Cameras de vigilancia')}
//         {renderSingleChart('ocupacion', 'Grado ocupation espacio')}
//         {renderSingleChart('Sistema_de_pago', 'Sistema de pago')}
//         {renderSingleChart('Cuno', 'Cuno salida')}
//       </div>
//     );
//   }

//   render() {
//     const { data, loading, error, selectedTab } = this.state;

//     if (loading) {
//       return <div><p>Cargando...</p></div>;
//     }

//     if (error) {
//       return <div><p>Error al obtener los datos</p></div>;
//     }

//     const tabData = data[selectedTab] || {};

//     return (
//       <div style={{ width: '100%', padding: '20px' }}>
//         <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//           {Object.keys(data).map(tab => (
//             <button
//               key={tab}
//               onClick={() => this.setState({ selectedTab: tab })}
//               style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}
//             >
//               <img src={tabImages[tab]} alt={tab} style={{ width: '20px', height: '20px', marginRight: '5px' }} />
//               {tab.replace(/_/g, ' ')}
//             </button>
//           ))}
//         </div>
//         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
//           {selectedTab === 'FICHA_Seguridad' ? (
//             this.renderFICHA_Seguridad(tabData)
//           ) : (
//             Object.keys(tabData).map((chartKey, index) => (
//               <div
//                 key={index}
//                 style={{ marginBottom: '20px' }}
//               >
//                 {this.renderChart(
//                   tabData[chartKey],
//                   Object.keys(tabData[chartKey][0] || {})[0] || 'No Data',
//                   'count',
//                   this.getChartLabel(chartKey)
//                 )}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     );
//   }
// }

// export default DataTable;
//------------------------------------------

// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import marketing from '../../public/images/Marketing.png';
// import ambientacion from '../../public/images/Ambientacion.png';
// import horarios from '../../public/images/Horarios.png';
// import datosGenerales from '../../public/images/DatosGenerales.png';
// import entorno from '../../public/images/Entorno.png';
// import espectaculo from '../../public/images/Espectaculo.png';
// import instalacion from '../../public/images/Instalacion.png';
// import personal from '../../public/images/Personal.png';
// import precios from '../../public/images/Precios.png';
// import rCSbuenasPracticas from '../../public/images/RCSbuenasPracticas.png';
// import rCSmalasPracticas from '../../public/images/RCSmalasPracticas.png';
// import seguridad from '../../public/images/Seguridad.png';
// import servicio from '../../public/images/Servicio.png';
// import valoracion from '../../public/images/valoracion.png';

// const tabImages = {
//   FICHA_AMBIENTE: marketing,
//   FICHA_ENCUESTA: ambientacion,
//   horarios: horarios,
//   DatosGenerales: datosGenerales,
//   FICHA_Entorno: entorno,
//   instalaciones_funcionamiento: espectaculo,
//   Instalacion: instalacion,
//   Personal: personal,
//   Precios: precios,
//   RCSbuenasPracticas: rCSbuenasPracticas,
//   RCSmalasPracticas: rCSmalasPracticas,
//   FICHA_Seguridad: seguridad,
//   Servicio: servicio,
//   Valoracion: valoracion
// };

// class DataTable extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: {},
//       loading: true,
//       error: false,
//       selectedTab: ''
//     };
//   }

//   componentDidMount() {
//     fetch('https://quality.fiestaismadrid.net/api/survey/list')
//       .then(response => {
//         if (!response.ok) throw new Error('Network response was not ok');
//         return response.json();
//       })
//       .then(jsonData => {
//         const firstTab = Object.keys(jsonData)[0] || '';
//         this.setState({
//           data: jsonData,
//           loading: false,
//           selectedTab: firstTab
//         });
//       })
//       .catch(error => {
//         console.error('Error fetching data:', error);
//         this.setState({
//           loading: false,
//           error: true
//         });
//       });
//   }

//   generateColors(dataLength) {
//     return Array.from({ length: dataLength }, () => {
//       const r = Math.floor(Math.random() * 256);
//       const g = Math.floor(Math.random() * 256);
//       const b = Math.floor(Math.random() * 256);
//       return `rgba(${r}, ${g}, ${b}, 0.6)`;
//     });
//   }

//   renderChart(dataArray, labelKey, countKey, chartLabel, xAxisLabel = 'Categories', yAxisLabel = 'Values') {
//     // Check if dataArray is null or empty to avoid rendering a broken chart
//     if (!dataArray || dataArray.length === 0) {
//       return (
//         <div style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
//           <p>No data available for this chart.</p>
//         </div>
//       );
//     }

//     const labels = dataArray.map(item => item && item.hasOwnProperty(labelKey) ? item[labelKey] : 'Unknown');
//     const counts = dataArray.map(item => item && item.hasOwnProperty(countKey) ? parseInt(item[countKey], 10) : 0);

//     const chartData = {
//       labels,
//       datasets: [{
//         label: chartLabel,
//         data: counts,
//         backgroundColor: this.generateColors(counts.length),
//         borderWidth: 1
//       }]
//     };

//     return (
//       <Bar
//         data={chartData}
//         options={{
//           maintainAspectRatio: false,
//           scales: {
//             xAxes: [{
//               // scaleLabel: {
//               //   display: true,
//               //   labelString: xAxisLabel
//               // },
//               ticks: {
//                 autoSkip: false
//               }
//             }],
//             yAxes: [{
//               scaleLabel: {
//                 display: true,
//                 labelString: yAxisLabel
//               },
//               ticks: {
//                 beginAtZero: true
//               }
//             }]
//           },
//           legend: {
//             display: true,
//             position: 'top'
//           },
//           tooltips: {
//             mode: 'index',
//             intersect: false
//           },
//           responsive: true
//         }}
//         height={385}
//         width={400}
//       />
//     );
//   }



//   renderTabData(tabData) {
//     return Object.entries(tabData).map(([chartKey, dataArray]) => {
//       if (!dataArray || dataArray.length === 0) {
//         // Handle the case where dataArray is empty or undefined
//         return (
//           <div key={chartKey} style={{ marginBottom: '20px', textAlign: 'center' }}>
//             <p>No data available for {chartKey.replace(/_/g, ' ')}</p>
//           </div>
//         );
//       }

//       const labelKey = dataArray[0] ? Object.keys(dataArray[0])[0] : 'DefaultLabel';
//       const countKey = dataArray[0] ? Object.keys(dataArray[0])[1] : 'DefaultCount';

//       // Continue to render the chart if dataArray[0] is defined
//       return (
//         <div key={chartKey} style={{ marginBottom: '20px' }}>
//           {this.renderChart(dataArray, labelKey, countKey, chartKey.replace(/_/g, ' '))}
//         </div>
//       );
//     });
//   }


//   render() {
//     const { data, loading, error, selectedTab } = this.state;

//     if (loading) {
//       return <div><p>Loading...</p></div>;
//     }

//     if (error) {
//       return <div><p>Error loading data: {error}</p></div>;
//     }

//     const tabData = data[selectedTab] || {};

//     return (
//       <div style={{ width: '100%', padding: '20px' }}>
//         <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//           {Object.keys(data).map(tab => (
//             <button
//               key={tab}
//               onClick={() => this.setState({ selectedTab: tab })}
//               style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}
//             >
//               <img src={tabImages[tab]} alt={tab} style={{ width: '20px', height: '20px', marginRight: '5px' }} />
//               {tab.replace(/_/g, ' ')}
//             </button>
//           ))}
//         </div>
//         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
//           {this.renderTabData(tabData)}
//         </div>
//       </div>
//     );
//   }
// }

// export default DataTable;
// import React, { Component } from 'react';
// import { Bar } from 'react-chartjs-2';
// import marketing from '../../public/images/Marketing.png';
// import ambientacion from '../../public/images/Ambientacion.png';
// import horarios from '../../public/images/Horarios.png';
// import datosGenerales from '../../public/images/DatosGenerales.png';
// import entorno from '../../public/images/Entorno.png';
// import espectaculo from '../../public/images/Espectaculo.png';
// import instalacion from '../../public/images/Instalacion.png';
// import personal from '../../public/images/Personal.png';
// import precios from '../../public/images/Precios.png';
// import rCSbuenasPracticas from '../../public/images/RCSbuenasPracticas.png';
// import rCSmalasPracticas from '../../public/images/RCSmalasPracticas.png';
// import seguridad from '../../public/images/Seguridad.png';
// import servicio from '../../public/images/Servicio.png';
// import valoracion from '../../public/images/valoracion.png';

// const tabImages = {
//   FICHA_AMBIENTE: marketing,
//   FICHA_ENCUESTA: ambientacion,
//   horarios: horarios,
//   DatosGenerales: datosGenerales,
//   FICHA_Entorno: entorno,
//   instalaciones_funcionamiento: espectaculo,
//   Instalacion: instalacion,
//   Personal: personal,
//   Precios: precios,
//   RCSbuenasPracticas: rCSbuenasPracticas,
//   RCSmalasPracticas: rCSmalasPracticas,
//   FICHA_Seguridad: seguridad,
//   Servicio: servicio,
//   Valoracion: valoracion
// };

// class DataTable extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: {},
//       loading: true,
//       error: false,
//       selectedTab: ''
//     };
//   }

//   componentDidMount() {
//     fetch('https://quality.fiestaismadrid.net/api/survey/list')
//       .then(response => {
//         if (!response.ok) throw new Error('Network response was not ok');
//         return response.json();
//       })
//       .then(jsonData => {
//         const firstTab = Object.keys(jsonData)[0] || '';
//         this.setState({
//           data: jsonData,
//           loading: false,
//           selectedTab: firstTab
//         });
//       })
//       .catch(error => {
//         console.error('Error fetching data:', error);
//         this.setState({
//           loading: false,
//           error: true
//         });
//       });
//   }

//   generateColors(dataLength) {
//     const colors = [];
//     for (let i = 0; i < dataLength; i++) {
//       const r = Math.floor(Math.random() * 256);
//       const g = Math.floor(Math.random() * 256);
//       const b = Math.floor(Math.random() * 256);
//       colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
//     }
//     return colors;
//   }

//   getChartLabel(chartKey) {
//     const chartLabels = {
//       licenciadata: 'Licenses',
//       dimensionesdata: 'Dimensions',
//       horaLde: 'Monday Start Time',
//       horaLa: 'Monday End Time',
//       horaMde: 'Tuesday Start Time',
//       horaMa: 'Tuesday End Time',
//       horaXde: 'Wednesday Start Time',
//       horaXa: 'Wednesday End Time',
//       horaJde: 'Thursday Start Time',
//       horaJa: 'Thursday End Time',
//       horaVde: 'Friday Start Time',
//       horaVa: 'Friday End Time',
//       horaSde: 'Saturday Start Time',
//       horaSa: 'Saturday End Time',
//       horaDde: 'Sunday Start Time',
//       horaDa: 'Sunday End Time',
//       musicaLdata: 'Ambience Monday',
//       musicaMdata: 'Ambience Tuesday',
//       musicaXdata: 'Ambience Wednesday',
//       MusicaJdata: 'Ambience Thursday',
//       musicaVdata: 'Ambience Friday',
//       musicaSdata: 'Ambience Saturday',
//       musicaDdata: 'Ambience Sunday',
//       edaddata: 'Age',
//       poderdata: 'Power',
//       aspectodata: 'Aspect',
//       pistadata: 'Dance Floor',
//       escenariodata: 'Stage',
//       zonamesasdata: 'Table Area',
//       perc_mesasdata: 'Percentage of Tables',
//       barrasdata: 'Bars',
//       barrasmetrosdata: 'Bars Meters',
//       barraspersonsdata: 'Bar Persons',
//       decoraciondata: 'Decoration',
//       climatizaciondata: 'Air Conditioning',
//       climat_tempdata: 'Climate Temperature',
//       limp_durantedata: 'Cleanliness During',
//       limp_ensesiondata: 'Cleanliness In Session',
//       mantenimientodata: 'Maintenance',
//       evacuation_entry: 'evacuacion',
//       controlaforo: 'Sistema control aforos',
//       hora_actv: 'En que horario se produce el pico de mas activided',
//       camaras: 'Cameras de vigilancia',
//       ocupacion: 'Grado ocupation espacio',
//       Sistema_de_pago: 'Sistema de pago',
//       Cuno: 'Cuno salida'
//     };
//     return chartLabels[chartKey] || chartKey.replace(/_/g, ' ');
//   }

//   renderChart(data, labelKey, countKey, chartLabel) {
//     const labels = data.map(item => item[labelKey] || 'Unknown');
//     const counts = data.map(item => parseInt(item[countKey], 10) || 0);

//     const chartData = {
//       labels: labels,
//       datasets: [
//         {
//           label: chartLabel,
//           data: counts,
//           backgroundColor: this.generateColors(counts.length),
//           borderWidth: 1
//         }
//       ]
//     };

//     return (
//       <Bar
//         data={chartData}
//         options={{
//           maintainAspectRatio: false,
//           scales: {
//             yAxes: [{
//               ticks: {
//                 beginAtZero: true
//               }
//             }]
//           }
//         }}
//         height={385}
//         width={400}
//       />
//     );
//   }

//   renderFICHA_Seguridad(data) {
//     const renderSingleChart = (key) => {
//       const dataObj = data[key][0];
//       const labels = Object.keys(dataObj);
//       const counts = labels.map(label => parseInt(dataObj[label], 10) || 0);

//       const chartData = {
//         labels: labels,
//         datasets: [{
//           label: this.getChartLabel(key),
//           data: counts,
//           backgroundColor: this.generateColors(counts.length),
//           borderWidth: 1
//         }]
//       };

//       return (
//         <div key={key}>
//           <Bar
//             data={chartData}
//             options={{
//               maintainAspectRatio: false,
//               scales: {
//                 yAxes: [{
//                   ticks: {
//                     beginAtZero: true
//                   }
//                 }]
//               }
//             }}
//             height={385}
//             width={400}
//           />
//         </div>
//       );
//     };
//     return (
//       <div>
//         {Object.keys(data).map(key => renderSingleChart(key))}
//       </div>
//     );
//   }

//   renderFICHA_Servicios(data) {
//     const renderSingleChart = (key) => {
//       const dataObj = data[key];
//       if (!Array.isArray(dataObj)) return null;

//       const labels = Object.keys(dataObj[0]);
//       const counts = labels.map(label => parseInt(dataObj[0][label], 10) || 0);

//       const chartData = {
//         labels: labels,
//         datasets: [{
//           label: this.getChartLabel(key),
//           data: counts,
//           backgroundColor: this.generateColors(counts.length),
//           borderWidth: 1
//         }]
//       };

//       return (
//         <div key={key}>
//           <Bar
//             data={chartData}
//             options={{
//               maintainAspectRatio: false,
//               scales: {
//                 yAxes: [{
//                   ticks: {
//                     beginAtZero: true
//                   }
//                 }]
//               }
//             }}
//             height={385}
//             width={400}
//           />
//         </div>
//       );
//     };
//     return (
//       <div>
//         {Object.keys(data).map(key => renderSingleChart(key))}
//       </div>
//     );
//   }

//   renderFICHA_Espectaculos(data) {
//     const renderSingleChart = (key) => {
//       const dataObj = data[key];
//       if (!Array.isArray(dataObj)) return null;

//       const labels = Object.keys(dataObj[0]);
//       const counts = labels.map(label => parseInt(dataObj[0][label], 10) || 0);

//       const chartData = {
//         labels: labels,
//         datasets: [{
//           label: this.getChartLabel(key),
//           data: counts,
//           backgroundColor: this.generateColors(counts.length),
//           borderWidth: 1
//         }]
//       };

//       return (
//         <div key={key}>
//           <Bar
//             data={chartData}
//             options={{
//               maintainAspectRatio: false,
//               scales: {
//                 yAxes: [{
//                   ticks: {
//                     beginAtZero: true
//                   }
//                 }]
//               }
//             }}
//             height={385}
//             width={400}
//           />
//         </div>
//       );
//     };
//     return (
//       <div>
//         {Object.keys(data).map(key => renderSingleChart(key))}
//       </div>
//     );
//   }

//   render() {
//     const { data, loading, error, selectedTab } = this.state;

//     if (loading) {
//       return <div><p>Loading...</p></div>;
//     }

//     if (error) {
//       return <div><p>Error fetching data</p></div>;
//     }

//     const tabData = data[selectedTab] || {};

//     return (
//       <div style={{ width: '100%', padding: '20px' }}>
//         <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
//           {Object.keys(data).map(tab => (
//             <button
//               key={tab}
//               onClick={() => this.setState({ selectedTab: tab })}
//               style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}
//             >
//               <img src={tabImages[tab]} alt={tab} style={{ width: '20px', height: '20px', marginRight: '5px' }} />
//               {tab.replace(/_/g, ' ')}
//             </button>
//           ))}
//         </div>
//         <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
//           {selectedTab === 'FICHA_Seguridad' ? (
//             this.renderFICHA_Seguridad(tabData)
//           ) : selectedTab === 'FICHA_Servicios' ? (
//             this.renderFICHA_Servicios(tabData)
//           ) : selectedTab === 'FICHA_Espectaculos' ? (
//             this.renderFICHA_Espectaculos(tabData)
//           ) : (
//             Object.keys(tabData).map((chartKey, index) => (
//               <div
//                 key={index}
//                 style={{ marginBottom: '20px' }}
//               >
//                 {this.renderChart(
//                   tabData[chartKey],
//                   Object.keys(tabData[chartKey][0] || {})[0] || 'No Data',
//                   'count',
//                   this.getChartLabel(chartKey)
//                 )}
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     );
//   }
// }

// export default DataTable;


import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import marketing from '../../public/images/Marketing.png';
import ambientacion from '../../public/images/Ambientacion.png';
import horarios from '../../public/images/Horarios.png';
import datosGenerales from '../../public/images/DatosGenerales.png';
import entorno from '../../public/images/Entorno.png';
import espectaculo from '../../public/images/Espectaculo.png';
import instalacion from '../../public/images/Instalacion.png';
import personal from '../../public/images/Personal.png';
import precios from '../../public/images/Precios.png';
import rCSbuenasPracticas from '../../public/images/RCSbuenasPracticas.png';
import rCSmalasPracticas from '../../public/images/RCSmalasPracticas.png';
import seguridad from '../../public/images/Seguridad.png';
import servicio from '../../public/images/Servicio.png';
import valoracion from '../../public/images/valoracion.png';

const tabImages = {
  FICHA_AMBIENTE: marketing,
  FICHA_ENCUESTA: ambientacion,
  horarios: horarios,
  DatosGenerales: datosGenerales,
  FICHA_Entorno: entorno,
  FICHA_Espectaculos: espectaculo,
  instalaciones_funcionamiento: instalacion,
  Personal: personal,
  Precios: precios,
  RCSbuenasPracticas: rCSbuenasPracticas,
  RCSmalasPracticas: rCSmalasPracticas,
  FICHA_Seguridad: seguridad,
  FICHA_Servicios: servicio,
  Valoracion: valoracion
};

class DataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      error: false,
      selectedTab: ''
    };
  }

  componentDidMount() {
    fetch('https://quality.fiestaismadrid.net/api/survey/list')
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(jsonData => {
        const firstTab = Object.keys(jsonData)[0] || '';
        this.setState({
          data: jsonData,
          loading: false,
          selectedTab: firstTab
        });
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        this.setState({
          loading: false,
          error: true
        });
      });
  }

  generateColors(dataLength) {
    const colors = [];
    for (let i = 0; i < dataLength; i++) {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      colors.push(`rgba(${r}, ${g}, ${b}, 0.6)`);
    }
    return colors;
  }

  getChartLabel(chartKey) {
    const chartLabels = {
      licenciadata: 'Licenses',
      dimensionesdata: 'Dimensions',
      horaLde: 'Monday Start Time',
      horaLa: 'Monday End Time',
      horaMde: 'Tuesday Start Time',
      horaMa: 'Tuesday End Time',
      horaXde: 'Wednesday Start Time',
      horaXa: 'Wednesday End Time',
      horaJde: 'Thursday Start Time',
      horaJa: 'Thursday End Time',
      horaVde: 'Friday Start Time',
      horaVa: 'Friday End Time',
      horaSde: 'Saturday Start Time',
      horaSa: 'Saturday End Time',
      horaDde: 'Sunday Start Time',
      horaDa: 'Sunday End Time',
      musicaLdata: 'Ambience Monday',
      musicaMdata: 'Ambience Tuesday',
      musicaXdata: 'Ambience Wednesday',
      MusicaJdata: 'Ambience Thursday',
      musicaVdata: 'Ambience Friday',
      musicaSdata: 'Ambience Saturday',
      musicaDdata: 'Ambience Sunday',
      edaddata: 'Age',
      poderdata: 'Power',
      aspectodata: 'Aspect',
      pistadata: 'Dance Floor',
      escenariodata: 'Stage',
      zonamesasdata: 'Table Area',
      perc_mesasdata: 'Percentage of Tables',
      barrasdata: 'Bars',
      barrasmetrosdata: 'Bars Meters',
      barraspersonsdata: 'Bar Persons',
      decoraciondata: 'Decoration',
      climatizaciondata: 'Air Conditioning',
      climat_tempdata: 'Climate Temperature',
      limp_durantedata: 'Cleanliness During',
      limp_ensesiondata: 'Cleanliness In Session',
      mantenimientodata: 'Maintenance',
      evacuation_entry: 'evacuacion',
      controlaforo: 'Sistema control aforos',
      hora_actv: 'En que horario se produce el pico de mas activided',
      camaras: 'Cameras de vigilancia',
      ocupacion: 'Grado ocupation espacio',
      Sistema_de_pago: 'Sistema de pago',
      Cuno: 'Cuno salida',
      // Custom labels for FICHA_Entorno
      urbanismo: "Configuracion urbanistica:",
      org_colas: "Sistema organizacion Coals:",
      espera_colas: "Tiempo de espera en cola",
      cola_reservas: "Cola",
      ruido_esterior: "La actividad del local produce ruido en el exterior:",
      botellon_ext: "Hay lateros y/o gente haciendo bolellon en el exterior:",
      protestas: "Hay pancartas de protesta de los vecinos:",
      // Custom labels for FICHA_Servicios
      marca_bebidas: 'Marcas bebidas:',
      vajilla: 'Vajilla:',
      hielo: 'Calidad hielo:',
      refresco: 'Uso de refresco:',
      amabilidad: 'Amabilidad Personal:',
      esperabarra: 'Tiempo de espera en barra',
      disp_alimentos: 'Dispensacion de alimentos:',
      mesas_reservados: 'MESAS y reservados:',
      mesas_num: 'Numero de mesas',
      mesas_percent: '% superficie local',
      venta_botellas: 'Venta por botellas',
      shisas: 'Shishas',
      // Custom labels for FICHA_Espectaculos
      amb_musical: 'Musical Ambience',
      estilo_musical: 'Musical Style',
      volumen_musica: 'Music Volume',
      animacion: 'Animation',
      visuales: 'Visuals',
      bengalas: 'Sparklers',
      ropia: 'Wardrobe',
      ropia_precio: 'Wardrobe Price',
      ropia_estado: 'Wardrobe Condition'
    };
    return chartLabels[chartKey] || chartKey.replace(/_/g, ' ');
  }

  getXAxisLabels(key) {
    const customLabels = {
      vajilla: ['Vaso tubo extra', 'Vaso tubo estandar', 'Copa balon', 'Vaso sidra', 'Vasos plastico', 'Otros'],
      hielo: ['Seleccionar', 'Macizo pequeño', 'Macizo grande', 'Hueco'],
      refresco: ['Seleccionar', 'Botellín vidrio', 'Pistola', 'Plastico', 'Lata'],
      amabilidad: ['Seleccionar', 'Muy Mala', 'Bastante mala', 'Bastante buena', 'Muy Buena'],
      esperabarra: ['Seleccionar', 'De 1 a 3 min.', 'inmediata', 'De 3 a 5 min.', ' Mas de 5 min.', 'Barra colapsada'],
      disp_alimentos: ['Seleccionar', 'Desgustación gratuita', 'Hamburguesía', 'No', 'Servicio de restauración', 'Vending'],
      mesas_reservados: ['No', 'Si'],
      mesas_num: ['No Data', '10'],
      mesas_percent: ['No Data', '10%'],
      venta_botellas: ['No', 'Si'],
      shisas: ['No', 'Si'],
      amb_musical: ['No', 'Residente', 'Playlist', 'Live Set', 'Grupos M'],
      estilo_musical: ['Comercial', 'Reggaeton', 'Electro', 'Remember', 'Other'],
      volumen_musica: ['No Data', 'Bastante alto'],
      animacion: ['No Data', 'Escenario'],
      visuales: ['No', 'Si'],
      bengalas: ['No', 'Si'],
      ropia: ['No', 'Si'],
      ropia_precio: ['No Data'],
      ropia_estado: ['No Data'],
      evacuation_entry: ['entrada', 'pista', 'Acceso WC', 'Barras', 'Otras'],
      ocupacion: ['Muy Saturado', 'Bastante Saturado', 'Poco Saturado', 'Nada Saturado'],
      hora_actv: ['Por la tarde', 'De 24:00h a 2:00h', 'De 2:00h a 4:00h', 'De 4:00h a cierre'],
      Sistema_de_pago: ['Efectivo', 'Tarjeta', 'Cashiess', 'Bizum'],
      espera_colas: ['16 a 30 minutos', '6 a 15 minutos'],
      marca_bebidas: ['Premium', 'Marcas estandar', 'Marcas blancas', 'Otras']
    };
    return customLabels[key] || [];
  }

  renderChart(data, labelKey, countKey, chartLabel, customLabels = []) {
    const labels = customLabels.length > 0 ? customLabels : data.map(item => item[labelKey] || 'Unknown');
    const counts = data.map(item => parseInt(item[countKey], 10) || 0);

    const chartData = {
      labels: labels,
      datasets: [
        {
          label: chartLabel,
          data: counts,
          backgroundColor: this.generateColors(counts.length),
          borderWidth: 1
        }
      ]
    };

    return (
      <Bar
        data={chartData}
        options={{
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }}
        height={385}
        width={400}
      />
    );
  }

  renderFICHA_Seguridad(data) {
    const renderSingleChart = (key) => {
      const dataObj = data[key][0];
      const labels = Object.keys(dataObj);
      const counts = labels.map(label => parseInt(dataObj[label], 10) || 0);
      const customLabels = this.getXAxisLabels(key);
      const chartData = {
        labels: customLabels.length > 0 ? customLabels : labels,
        datasets: [{
          label: this.getChartLabel(key),
          data: counts,
          backgroundColor: this.generateColors(counts.length),
          borderWidth: 1
        }]
      };

      return (
        <div key={key}>
          <Bar
            data={chartData}
            options={{
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }}
            height={385}
            width={400}
          />
        </div>
      );
    };
    return (
      <div>
        {Object.keys(data).map(key => renderSingleChart(key))}
      </div>
    );
  }

  renderFICHA_Servicios(data) {
    const renderSingleChart = (key) => {
      const dataObj = data[key];
      if (!Array.isArray(dataObj)) return null;

      const labels = Object.keys(dataObj[0]);
      const counts = labels.map(label => parseInt(dataObj[0][label], 10) || 0);

      const customLabels = this.getXAxisLabels(key);

      const chartData = {
        labels: customLabels.length > 0 ? customLabels : labels,
        datasets: [{
          label: this.getChartLabel(key),
          data: counts,
          backgroundColor: this.generateColors(counts.length),
          borderWidth: 1
        }]
      };

      return (
        <div key={key}>
          <Bar
            data={chartData}
            options={{
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }}
            height={385}
            width={400}
          />
        </div>
      );
    };
    return (
      <div>
        {Object.keys(data).map(key => renderSingleChart(key))}
      </div>
    );
  }

  renderFICHA_Espectaculos(data) {
    const renderSingleChart = (key) => {
      const dataObj = data[key];
      if (!Array.isArray(dataObj)) return null;

      const labels = Object.keys(dataObj[0]);
      const counts = labels.map(label => parseInt(dataObj[0][label], 10) || 0);

      const customLabels = this.getXAxisLabels(key);

      const chartData = {
        labels: customLabels.length > 0 ? customLabels : labels,
        datasets: [{
          label: this.getChartLabel(key),
          data: counts,
          backgroundColor: this.generateColors(counts.length),
          borderWidth: 1
        }]
      };

      return (
        <div key={key}>
          <Bar
            data={chartData}
            options={{
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  }
                }]
              }
            }}
            height={385}
            width={400}
          />
        </div>
      );
    };
    return (
      <div>
        {Object.keys(data).map(key => renderSingleChart(key))}
      </div>
    );
  }

  render() {
    const { data, loading, error, selectedTab } = this.state;

    if (loading) {
      return <div><p>Loading...</p></div>;
    }

    if (error) {
      return <div><p>Error fetching data</p></div>;
    }

    const tabData = data[selectedTab] || {};

    return (
      <div style={{ width: '100%', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          {Object.keys(data).map(tab => (
            <button
              key={tab}
              onClick={() => this.setState({ selectedTab: tab })}
              style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}
            >
              <img src={tabImages[tab]} alt={tab} style={{ width: '20px', height: '20px', marginRight: '5px' }} />
              {tab.replace(/_/g, ' ')}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
          {selectedTab === 'FICHA_Seguridad' ? (
            this.renderFICHA_Seguridad(tabData)
          ) : selectedTab === 'FICHA_Servicios' ? (
            this.renderFICHA_Servicios(tabData)
          ) : selectedTab === 'FICHA_Espectaculos' ? (
            this.renderFICHA_Espectaculos(tabData)
          ) : (
            Object.keys(tabData).map((chartKey, index) => (
              <div
                key={index}
                style={{ marginBottom: '20px' }}
              >
                {this.renderChart(
                  tabData[chartKey],
                  Object.keys(tabData[chartKey][0] || {})[0] || 'No Data',
                  'count',
                  this.getChartLabel(chartKey),
                  this.getXAxisLabels(chartKey)
                )}
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
}

export default DataTable;












// WEBPACK FOOTER //
// ./websources/views/Dashboard/SurveryGraph.js